<template>
<div class="edu-records">
    <nav class="edu-record-breadcrumb" aria-label="页面位置"><router-link to="/home/index">首页</router-link><v-icon size="13">mdi-chevron-right</v-icon><span>教务中心</span><v-icon size="13">mdi-chevron-right</v-icon><span>点名记录</span></nav>
    <header class="edu-record-heading"><h1>点名记录</h1><p>查看学员到课、课时扣减与课堂反馈，跟进每一次学习。</p></header><section class="edu-record-filters" aria-label="筛选点名记录"><div class="edu-record-filter-title"><h2>筛选点名记录</h2><span>按班级、学员与课堂状态查询</span></div>
      <form @submit.prevent="queryClicked"><div class="edu-record-fields "><v-select v-model="query.classId" :items="selectClassList" item-text="className" item-value="id" label="班级" aria-label="班级" dense outlined hide-details color="#d9363e" clearable />
<v-select v-model="query.teacher" :items="selectTeacherList" item-text="trueName" item-value="id" label="授课老师" aria-label="授课老师" dense outlined hide-details color="#d9363e" clearable />
<studentSearchBox class="edu-record-student-search" @inputValue="setInputValue" />
<v-menu v-model="menu1" :close-on-content-click="false" offset-y min-width="auto"><template v-slot:activator="{ on, attrs }"><v-text-field v-model="query.start" label="上课开始日期" aria-label="上课开始日期" readonly dense outlined clearable hide-details color="#d9363e" v-bind="attrs" v-on="on" /></template><v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu>
<v-menu v-model="menu2" :close-on-content-click="false" offset-y min-width="auto"><template v-slot:activator="{ on, attrs }"><v-text-field v-model="query.end" label="上课结束日期" aria-label="上课结束日期" readonly dense outlined clearable hide-details color="#d9363e" v-bind="attrs" v-on="on" /></template><v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu>
<v-select v-model="query.status" :items="statusItems" item-text="statusName" item-value="id" label="到课状态" aria-label="到课状态" dense outlined hide-details color="#d9363e"  />
<v-select v-model="query.isBuke" :items="bukeItems" item-text="text" item-value="id" label="是否补课" aria-label="是否补课" dense outlined hide-details color="#d9363e" :disabled="query.status=='1'" />
<v-select v-model="query.isRate" :items="rateItems" item-text="rateName" item-value="id" label="是否点评" aria-label="是否点评" dense outlined hide-details color="#d9363e"  />
<v-select v-model="query.isGive" :items="giveItems" item-text="name" item-value="id" label="是否奖励" aria-label="是否奖励" dense outlined hide-details color="#d9363e"  /></div>
      <div class="edu-record-filter-bottom"><span>查询当前校区的记录</span><div class="edu-record-filter-actions"><v-btn depressed class="edu-record-query" type="submit" :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form>
    </section>
    <section class="edu-record-list" aria-label="点名记录列表"><div class="edu-record-toolbar"><h2>点名记录</h2><span class="edu-record-count">共 <strong>{{data.total}}</strong> 条</span><span class="edu-record-toolbar-note">到课 · 点评 · 积分 · 补课</span></div>
      <v-data-table :headers="data.headers" v-model="selectedItems" :items="data.list" :loading="query.loading" :mobile-breakpoint="0" class="edu-record-table" disable-pagination hide-default-footer item-key="id" loading-text="正在加载点名记录…" no-data-text="暂无符合条件的点名记录">
        <template v-slot:item.studentName="{item}"><strong class="edu-record-name">{{item.studentName || '—'}}</strong></template>
        <template v-slot:item.classDate="{item}"><div>{{item.classDate || '—'}}</div><div v-if="item.timeFrom && item.timeTo" class="edu-record-secondary">{{item.timeFrom}}–{{item.timeTo}}</div></template>
        <template v-slot:item.status="{item}">
					<span class="edu-record-status edu-record-status-success" v-if="item.status==='1'">到课</span>
					<span class="edu-record-status edu-record-status-warning" v-if="item.status==='2'">请假</span>
					<span class="edu-record-status edu-record-status-danger" v-if="item.status==='3'">旷课</span>
				</template>
				<template v-slot:item.studentType="{item}">
					<span v-if="item.studentType==='1'">固定学员</span>
					<span v-if="item.studentType==='2'" class="edu-record-text-success">预约学员</span>
					<span v-if="item.studentType==='3'" class="edu-record-text-pending">插班补课</span>
				</template>
				<template v-slot:item.reduceAmount="{item}">
					<span v-if="item.consumeType==='1'">-</span>
					<span v-if="item.consumeType==='2'">{{item.reduceAmount}}</span>
				</template>
				<template v-slot:item.isRate="{item}">
					<template v-if="item.status == '1'">
						<span v-if="item.isRate === '1'">已点评</span>
						<span v-if="item.isRate === '0'" class="edu-record-text-pending">未点评</span>
					</template>
					<template v-else>
						<span>-</span>
					</template>
				</template>
				<template v-slot:item.isGivePoint="{item}">
					<template v-if="item.status == '1'">
						<span v-if="item.isGivePoint === '1'">已奖励</span>
						<span v-if="item.isGivePoint === '0'" class="edu-record-text-pending">未奖励</span>
					</template>
					<template v-else>
						<span>-</span>
					</template>
				</template>
				<template v-slot:item.isBuke="{item}">
					<template v-if="item.status !== '1'">
						<span v-if="item.isBuke === '1'">已补</span>
						<span v-if="item.isBuke === '0'" class="edu-record-text-pending">未补</span>
					</template>
					<template v-else>
						<span>-</span>
					</template>
				</template>
				<template v-slot:item.action="{item}">
					<v-menu bottom>
						<template v-slot:activator="{ attrs, on }">
							<v-btn class="edu-record-menu-button" outlined v-bind="attrs" v-on="on" small height="30px">
								操作
							</v-btn>

						</template>
						<v-list>
							<v-list-item class="justify-center">
								<v-btn @click.stop="showRateDialog(item)" :disabled="item.isRate !== '0' || item.status !=='1'" color="#b94852" text small>
									课堂点评
								</v-btn>
							</v-list-item>
							<v-list-item class="justify-center">
								<v-btn @click.stop="showGivePointDialog(item)" :disabled="item.isGivePoint !== '0' || item.status !=='1'" color="#528367" text small>
									奖励积分
								</v-btn>
							</v-list-item>
							<v-list-item class="justify-center">
								<v-btn @click.stop="showBukeDialog(item)" :disabled="item.status === '1'  || item.isBuke !=='0'" color="#528367" text small>
									插班补课
								</v-btn>
							</v-list-item>
						</v-list>
					</v-menu>

				</template>

			</v-data-table><div class="edu-record-pagination"><div class="edu-record-page-total"><span>共 {{data.total}} 条记录</span><v-select :items="[10,20,50,100]" @change="handleSizeChange" dense hide-details label="每页数量" aria-label="每页数量" outlined v-model="query.size" color="#d9363e" /></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="5" v-model="query.page" color="#d9363e" /></div></section>
    <!-- 奖励积分组件 -->
		<giveStudentPoint :show="givePoint.dialog" :detailId="givePoint.detailId" :studentName="givePoint.studentName"
			@cancel="givePoint.dialog=false" @success="givePointSuccess"></giveStudentPoint>
		<!-- 点评组件 -->
		<rateStudentClass :show="rate.show" :detailId="rate.detailId" :studentName="rate.studentName"
			@cancel="rate.show=false" @success="rateSuccess"></rateStudentClass>

		<!-- 补课组件 -->
		<makeUpMissedLesson :show="buke.show" :recordDetail="buke.recordDetail"
			@cancel="buke.show=false" @success="bukeSuccess"></makeUpMissedLesson>
	</div>
</template>

<script>
	import utils from "../../../config/utils"
	import giveStudentPoint from "../../../components/give_student_point.vue"
	import rateStudentClass from "../../../components/rate_student_class.vue"
	import makeUpMissedLesson from "../../../components/make_up_missed_lesson.vue"
	import studentSearchBox from "../../../components/student_search_box.vue"
	export default {
		name: "class-record-detail-list",
		components:{giveStudentPoint,rateStudentClass,makeUpMissedLesson,studentSearchBox},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				selectedItems: [], //选中的行
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '点名记录',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '上课时间',
							value: 'classDate',
							sortable: false,
								
						},
						{
							text: '课程',
							value: 'courseName',
							sortable: false,
						},
						{
							text: '班级',
							value: 'className',
							sortable: false,
						},
						{
							text: '主课老师',
							value: 'teacherName',
							sortable: false,
						},
						{
							text: '教室',
							value: 'roomName',
							sortable: false,
						},
						{
							text: '学员姓名',
							value: 'studentName',
							sortable: false,
						},
						{
							text: '学员类型',
							value: 'studentType',
							sortable: false,
						},
						{
							text: '上课状态',
							value: 'status',
							sortable: false,
						},
						{
							text: '扣课时',
							value: 'reduceQty',
							sortable: false,
						},
						{
							text: '扣学费',
							value: 'reduceAmount',
							sortable: false,
						},
						{
							text: '是否点评',
							value: 'isRate',
							sortable: false,
			
						},
						{
							text: '奖励积分',
							value: 'isGivePoint',
							sortable: false,
				
						},
						{
							text: '是否补课',
							value: 'isBuke',
							sortable: false,
										
						},
						{
							text: '操作',
							value: 'action',
							align:'center',
							sortable: false
						},
					],
					list: [],
				},
				selectCourseList: [], //选择课程数据源
				selectClassList: [], //选择课程数据源
				selectTeacherList: [], //选择老师数据源
				selectClassroomList: [], //选择教室数据源
				statusItems: [{
						id: "",
						statusName: "全部"
					},
					{
						id: "1",
						statusName: "到课"
					},
					{
						id: "5",
						statusName: "缺课"
					},
					{
						id: "2",
						statusName: "请假"
					},
					{
						id: "3",
						statusName: "旷课"
					},
				],
				rateItems: [{
						id: "",
						rateName: "全部"
					},
					{
						id: "0",
						rateName: "未点评"
					},
					{
						id: "1",
						rateName: "已点评"
					},
				],
				bukeItems:[
					{id:"",text:"全部"},
					{id:"0",text:"未补"},
					{id:"1",text:"已补"},
				],
				giveItems:[
					{id:"",name:"全部"},
					{id:"0",name:"未奖励"},
					{id:"1",name:"已奖励"}
				],
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					shopId: "",
					classId: "",
					roomId: "",
					teacher: "",
					status: "",
					isRate:"",
					isGive:"",
					isBuke:"",
					studentName:""
				},
				
				givePoint: {
					dialog: false,
					studentName: "",
					detailId: "",
				},
				rate:{
					// 点评组件控制参数
					show:false,
					detailId:"",
					studentName:""
					
				},
				buke:{
					show:false,
					recordDetail:null
				}
				
			}
		},
		created() {
			const shopId = utils.getCurrentShopId();
			
			this.getClassListForSelect(shopId);
			this.getTeacherListForSelect(shopId);
			this.getClassroomListForSelect(shopId);
			
			this.getTableDataList();
		},
		methods: {
			
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			
			showRateDialog(item) {
				
				this.rate.show = true;
				this.rate.detailId = item.id;
				this.rate.studentName = item.studentName;

			},
			rateSuccess(){
				// 点评成功的回调
				this.rate.show = false;
				this.getTableDataList();
			},
			showGivePointDialog(item) {
				
				// 显示积分奖励组件
				this.givePoint.dialog = true;
				this.givePoint.detailId = item.id;
				this.givePoint.studentName = item.studentName;
				
			
			},
			givePointSuccess(){
				// 奖励积分成功
				this.givePoint.dialog= false;
				this.getTableDataList();
			},
			showBukeDialog(item){
				this.buke.recordDetail = item;
				this.buke.show = true;
			},
			bukeSuccess(){
				this.buke.show = false;
				this.getTableDataList();
			},
			setInputValue(value){
				// 搜索框输入的值
			
				this.query.studentName = value;
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				const shopId = utils.getCurrentShopId();

				let url = `/edu/class/record/detail/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.classId) {
					url += "&classId=" + this.query.classId;
				}
				
				if (this.query.roomId) {
					url += "&roomId=" + this.query.roomId;
				}
				if (this.query.teacher) {
					url += "&teacher=" + this.query.teacher;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				if (this.query.isRate) {
					url += "&isRate=" + this.query.isRate;
				}
				if (this.query.isGive) {
					url += "&isGive=" + this.query.isGive;
				}
				if (this.query.isBuke) {
					url += "&isBuke=" + this.query.isBuke;
				}
				if (this.query.studentName) {
					url += "&studentName=" + encodeURIComponent(this.query.studentName.trim());
				}
			
				this.axios.get(url).then(response => {



					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			weekName(wk) {

				let stName = "未知";
				this.weekItems.forEach((item, index) => {
					if (item.id == wk) {
						stName = item.weekName;

					}
				})
				return stName;
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "到课";
				} else if (state === "2") {
					stName = "请假";
				} else if (state === "3") {
					stName = "旷课";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "warning";
				} else if (state === "3") {
					color = "error";
				}

				return color;
			},
			consumeTypeColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "2") {
					color = "green";
				}

				return color;
			},
			consumeTypeName(state) {
				let color = "未知";
				if (state === "1") {
					color = "扣课时";
				} else if (state === "2") {
					color = "扣金额";
				}

				return color;
			},

			getClassListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/class/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectClassList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCourseListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/course/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getTeacherListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/teacher/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getClassroomListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/classroom/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectClassroomList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},

		}
	}
</script>

<style scoped lang="scss">
@import "../../../assets/styles/edu-records.scss";

</style>
